export enum LogLevel {
    Debug,
    Error,
    Info,
    Success,
    Warning
}
